import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLogoutSessionCleaner } from '../../hooks';
import { ReactComponent as LogoutIcon } from '../../assets/sideMenu/logout.svg';
import petCloudPaw from '../../assets/sideMenu/petcloud-paw.svg';
import petCloudText from '../../assets/sideMenu/petcloud-text.svg';
import { ImpersonateBanner } from './ImpersonateBanner';
import { LanguageComboBox } from './LanguageComboBox';

const Header = ({
  centered = false,
  isBurgerMenuHidden = false,
  noMultilanguage = false,
  showLogout = false,
}) => {
  const { t } = useTranslation('sideMenu');
  const { logout } = useLogoutSessionCleaner();

  return (
    <div className="Main-header-container">
      <div className="Main-header">
        <div
          className={'Main-header-logo'
            + `${isBurgerMenuHidden ? '-no-burger-menu' : ''}`
            + `${centered ? ' Main-header-centered' : ''}`}
        >
          <img alt="" src={petCloudPaw} />

          <img alt="" src={petCloudText} />
        </div>

        <div>
          {!noMultilanguage && <LanguageComboBox />}

          {showLogout && (
            <button
              aria-label={t('logout')}
              className="Main-header-logout"
              onClick={logout}
              title={t('logout')}
              type="button"
            >
              <LogoutIcon
                aria-hidden="true"
                className="Main-header-logout-icon"
                focusable="false"
              />

              <span className="Main-header-logout-label">{t('logout')}</span>
            </button>
          )}
        </div>
      </div>

      <ImpersonateBanner />
    </div>
  );
};

export default Header;
